import { Component, OnInit, OnDestroy, Input, ViewChild } from '@angular/core';
import { Project } from '../../../data/project/project';
import { OverlayPanel } from 'primeng/overlaypanel';
import { DeviceDetectorService } from 'ngx-device-detector';
import { MatDialog } from '@angular/material/dialog';
import { CustomerService } from '../../../../customer/data/customer.service';
import { ProjectService } from '../../../data/project/project.service';
import { Subscription } from 'rxjs';
import { ContactInfo } from '../../../../customer/data/contactInfo';

@Component({
    selector: 'app-contact-info-block',
    templateUrl: './contact-info-block.component.html',
    styleUrls: ['./contact-info-block.component.scss'],
    providers: [DeviceDetectorService]
})
export class ContactInfoBlockComponent implements OnInit, OnDestroy {

    @ViewChild('searchOP', { static: true })
    searchOP: OverlayPanel

    searchValue: string;

    @Input()
    nfsContact: ContactInfo;

    constructor(
        protected deviceDetector: DeviceDetectorService,
        protected dialog: MatDialog,
        protected customerService: CustomerService,
        protected projectService: ProjectService,
    ) {
    }

    ngOnInit() {
    }

    callPhone() {
        if (this.deviceDetector.isMobile() || this.deviceDetector.isTablet()) {
            if (this.nfsContact.phone1) {
                window.open('tel:' + this.nfsContact.phone1);
            }
        }
    }

    sendEmail() {
        if (this.nfsContact.email) {
            window.open('email:' + this.nfsContact.email);
        }
    }

    ngOnDestroy() {
    }

}
